"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogState = void 0;
var DialogState = exports.DialogState = /*#__PURE__*/function (DialogState) {
  DialogState[DialogState["CLOSED"] = 0] = "CLOSED";
  DialogState[DialogState["MESSAGE"] = 1] = "MESSAGE";
  DialogState[DialogState["ERROR"] = 2] = "ERROR";
  DialogState[DialogState["SETTINGS"] = 3] = "SETTINGS";
  DialogState[DialogState["HELP"] = 4] = "HELP";
  DialogState[DialogState["AUTOPLAY"] = 5] = "AUTOPLAY";
  DialogState[DialogState["PAYTABLE"] = 6] = "PAYTABLE";
  DialogState[DialogState["BET"] = 7] = "BET";
  DialogState[DialogState["PROMOTION_START"] = 8] = "PROMOTION_START";
  DialogState[DialogState["PROMOTION_END"] = 9] = "PROMOTION_END";
  DialogState[DialogState["INSUFFICIENT_BALANCE"] = 10] = "INSUFFICIENT_BALANCE";
  DialogState[DialogState["LIMITS_REACHED"] = 11] = "LIMITS_REACHED";
  DialogState[DialogState["TIME_LIMIT_REACHED"] = 12] = "TIME_LIMIT_REACHED";
  DialogState[DialogState["RG_REMINDER"] = 13] = "RG_REMINDER";
  DialogState[DialogState["UNFINISHED_GAME"] = 14] = "UNFINISHED_GAME";
  DialogState[DialogState["PLAYFORREAL"] = 15] = "PLAYFORREAL";
  DialogState[DialogState["PROMOTION_NEXT"] = 16] = "PROMOTION_NEXT";
  DialogState[DialogState["BLITZ_FEATURE"] = 17] = "BLITZ_FEATURE";
  DialogState[DialogState["HISTORY"] = 18] = "HISTORY";
  DialogState[DialogState["REPLAY_START"] = 19] = "REPLAY_START";
  DialogState[DialogState["REPLAY_END"] = 20] = "REPLAY_END";
  DialogState[DialogState["REPLAY_START_LAUNCH"] = 21] = "REPLAY_START_LAUNCH";
  DialogState[DialogState["REPLAY_END_LAUNCH"] = 22] = "REPLAY_END_LAUNCH";
  DialogState[DialogState["REPLAY_DEMO"] = 23] = "REPLAY_DEMO";
  DialogState[DialogState["CUSTOM"] = 24] = "CUSTOM";
  return DialogState;
}({});
//# sourceMappingURL=DialogState.js.map